import * as s from "./card.module.css";

// Re-export in TS to aid editor auto-completion
export const Card = {
  solid: s.solid,
  glass: s.glass,
};
